export enum AuthProvidersEnum {
  GOOGLE = 'google',
  APPLE = 'apple',
  EMAIL = 'email',
}

export const ProvderToProviderIdMatch = {
  [AuthProvidersEnum.GOOGLE]: 'google.com',
  [AuthProvidersEnum.APPLE]: 'apple.com',
};
